import { DependencyTemplateServiceData } from 'services/GameHosting/DeploymentTemp/deploymentTemplateServiceType';

export const FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE = 'FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE = 'CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE = 'UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE = 'DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const REPLICATE_TEMPLATE = 'REPLICATE_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const SORT = 'SORT_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const CANCEL_EDITION = 'CANCEL_EDITION_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const RESET_REDUCER = 'RESET_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export const CLEAN_ERROR = 'CLEAN_ERROR_DEPENDENCY_DEPLOYMENT_TEMPLATE';

export type DependencyTemplateReducer = {
  dependencyDepTemp: DependencyTemplateServiceData[];
  fetchIsCompleted: boolean;
  fetchIsPending: boolean;
  fetchIsError: null | boolean;
  addIsError: null | boolean;
  createIsCompleted: boolean;
  createIsPending: boolean;
  createIsError: null | boolean;
  updateIsPending: boolean;
  updateIsCompleted: boolean;
  updateIsError: null | boolean;
};
